import { Box, Paper, Typography } from '@mui/material';

interface Props {
  title: string;
  children: React.ReactNode;
}

export default function FormWrapper({ title, children }: Props) {
  return (
    <Box
      sx={{
        m: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        component={Paper}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          maxWidth: '800px',
          margin: '0 auto',
          borderRadius: 2,
          boxShadow: (theme) => theme.shadows[3],
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            mb: { xs: 2, sm: 3, md: 4 },
            fontSize: { xs: '1.5rem', sm: '2rem' },
            fontWeight: 500,
            color: 'primary.main',
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          {title}
        </Typography>
        {children}
      </Box>
    </Box>
  );
}
